export interface AvatarOrganization {
  id: string;
  name: string;
}

export enum AvatarStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
  DELETED = 'DELETED',
}

export interface AvatarHistory {
  id: string;
  fileName: string;
  tenants: string[];
  organizations: AvatarOrganization[];
  category: string;
  genders: string[];
  status: AvatarStatus;
  expiryDate: string;
  fileId: string;
  starCost: number;
  isEnabledForAllOrgs: boolean;
}
